var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"tag":"form"},scopedSlots:_vm._u([{key:"default",fn:function(validationObserver){return [_c('product-form-fields',{attrs:{"product":_vm.product,"validationObserver":validationObserver}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }